export const roleManagementStyles = {
  container: {
    p: 3,
  },
  
  headerBox: {
    mb: 4,
  },
  
  headerTitle: {
    fontWeight: 700,
    mb: 1,
  },
  
  headerSubtitle: {
    color: 'text.secondary',
  },
  
  companySelectorPaper: {
    p: 3,
    mb: 4,
    borderRadius: 3,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
  },
  
  companySelectorHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    mb: 2,
  },
  
  companySelectorAvatar: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    color: 'white',
    width: 48,
    height: 48,
  },
  
  companySelectorHeaderContent: {
    flex: 1,
  },
  
  companySelectorTitle: {
    fontWeight: 600,
    mb: 0.5,
  },
  
  companySelectorSubtitle: {
    opacity: 0.9,
  },
  
  companySelectorFormControl: {
    width: '100%',
  },
  
  companySelectorInputLabel: {
    color: 'white',
    '&.Mui-focused': { color: 'white' },
  },
  
  companySelectorSelect: {
    backgroundColor: 'rgba(255,255,255,0.1)',
    color: 'white',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255,255,255,0.3)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(255,255,255,0.5)',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'white',
    },
    '& .MuiSvgIcon-root': {
      color: 'white',
    },
  },
  
  companySelectorMenuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  
  selectedCompanyBox: {
    mt: 2,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  
  selectedCompanyChip: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    color: 'white',
    fontWeight: 600,
  },
  
  warningAlert: {
    mb: 4,
    borderRadius: 2,
  },
  
  rolesGrid: {
    mb: 4,
  },
  
  roleCard: (canModify, isProtected) => ({
    borderRadius: 3,
    border: isProtected ? '2px solid' : '1px solid',
    borderColor: isProtected ? 'error.main' : 'divider',
    opacity: !canModify ? 0.75 : 1,
    boxShadow: canModify
      ? '0 8px 24px rgba(0,0,0,0.12)'
      : '0 4px 8px rgba(0,0,0,0.06)',
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      boxShadow: canModify
        ? '0 12px 32px rgba(0,0,0,0.16)'
        : '0 4px 8px rgba(0,0,0,0.06)',
    },
  }),
  
  protectedChip: {
    position: 'absolute',
    top: 16,
    right: 16,
    zIndex: 1,
    pointerEvents: 'none',
    cursor: 'default',
  },
  
  roleAvatar: (color) => ({
    width: 56,
    height: 56,
    backgroundColor: `${color}.light`,
    color: `${color}.dark`,
  }),
  
  roleTitleBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexWrap: 'wrap',
  },
  
  roleTitle: {
    fontWeight: 600,
  },
  
  roleKeyChip: {
    pointerEvents: 'none',
    cursor: 'default',
  },
  
  roleProtectedChip: {
    pointerEvents: 'none',
    cursor: 'default',
  },
  
  roleDescription: {
    mt: 0.5,
  },
  
  roleContent: {
    pt: 0,
  },
  
  screenGrid: {
    spacing: 2,
  },
  
  screenBox: {
    p: 2,
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 2,
    backgroundColor: 'grey.50',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'grey.100',
      borderColor: 'primary.light',
    },
  },
  
  screenTitle: {
    fontWeight: 600,
    mb: 1.5,
    color: 'primary.main',
  },
  
  permissionsBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  
  permissionSwitch: (hasPermission) => ({
    '& .MuiSwitch-thumb': {
      boxShadow: hasPermission
        ? '0 2px 6px rgba(0,0,0,0.2)'
        : 'none',
    },
  }),
  
  permissionLabel: (hasPermission) => ({
    fontWeight: hasPermission ? 600 : 400,
    color: hasPermission
      ? 'text.primary'
      : 'text.secondary',
  }),
  
  permissionFormControlLabel: (canModify) => ({
    margin: 0,
    opacity: !canModify ? 0.6 : 1,
  }),
  
  summaryCard: {
    borderRadius: 3,
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
  },
  
  summaryHeader: {
    pb: 1,
  },
  
  summaryTitle: {
    fontWeight: 600,
    color: 'primary.main',
  },
  
  summaryStatBox: (color) => ({
    textAlign: 'center',
    p: 2,
    borderRadius: 2,
    backgroundColor: `${color}.light`,
    color: `${color}.dark`,
  }),
  
  summaryStatNumber: {
    fontWeight: 800,
    mb: 1,
  },
  
  summaryStatLabel: {
    fontWeight: 600,
  },
  
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 400,
  },
}; 